export default __webpack_public_path__ + "static/label-icon.url-5784170c5ea785b1d3f7aeb72fee7cf9.svg";